import { CommandType } from '../constants/Constants';
/**
 * 命令基类
 *
 * @export
 * @class BaseCommand
 * @author zhenliang.sun
 */
export default class BaseCommand {
  constructor() {
    this.type = CommandType.Normal;
    this.app = null;
    this.executing = false;
  }

  execute() {
    this.executing = true;
  }

  complete() {
    this.executing = false;
  }

  get stage() {
    return this.app.stage;
  }

  get root() {
    return this.stage.root;
  }
}
